import { Link } from "found";
import { makeStyles } from "@mui/styles";
import CustomerStatusChip from "./components/CustomerStatusChip";
import React from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import logo from "../../../../../assets/logo.png";

const useStyles = makeStyles(theme => ({
  base: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    padding: theme.spacing(2)
  },
  customerName: {
    marginRight: theme.spacing(2)
  },
  customerNameStatusWrapper: {
    alignItems: "center",
    display: "flex",
    marginBottom: theme.spacing(2)
  },
  historyResearchCenterContainer: {
    alignSelf: "flex-start"
  },
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0
  },
  logo: {
    width: 40,
    marginRight: theme.spacing(2),
    height: 40
  },
  orderContainer: {
    margin: theme.spacing(2)
  },
  orderHistoryButton: {
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5)
  },
  toolbar: {
    justifyContent: "space-between"
  },
  researchCenterLink: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
    fontWeight: theme.typography.fontWeightMedium
  }
}));

const HeaderToolbar = ({ order }) => {
  const classes = useStyles();

  const {
    orderNumber,
    primaryCustomer: { name_headerToolbar, status, id, totalOrderCount }
  } = order;

  return (
    <div className={classes.base}>
      <Toolbar className={classes.toolbar}>
        <div>
          <div className={classes.customerNameStatusWrapper}>
            <img className={classes.logo} src={logo} alt="logo" />
            <Typography
              className={classes.customerName}
              variant="h4"
              color="inherit"
            >
              {`${name_headerToolbar || "N/A"} (${totalOrderCount || ""})`}
            </Typography>
            <CustomerStatusChip borderColor={"#FFFFFF"} status={status} />
          </div>
          <Typography variant="h4" color="inherit">
            {`Order #${orderNumber}`}
          </Typography>
        </div>
        <div className={classes.historyResearchCenterContainer}>
          <Typography variant="body2">
            <Link
              className={classes.researchCenterLink}
              to={`/apps/production/customers/${id}`}
            >
              Visit Research Center
            </Link>
          </Typography>
        </div>
      </Toolbar>
    </div>
  );
};

export default HeaderToolbar;
